import React from 'react';
import { FormattedMessage } from 'react-intl';

import ProductPage from '../../components/ProductPage';
import Layout from '../../components/Layout';
import messages from './messages';

const pricing = [
  {
    title: messages.starter,
    monthlyPrice: 29,
    monthlyPayment: messages.monthlyPayment,
    limitMessage: messages.limitMessageStarter,
    featureList: [
      messages.featureApiKeyStats,
      messages.featureDashboard,
      messages.featureProductDefinition,
      messages.featureLicenseDefinition,
      messages.featureManageCustomers,
      messages.featureApiKeyDefinition,
      messages.featureApiKeyValidity,
      messages.featureLimits,
      messages.featureActiveApiKeys,
      messages.featureRequestsPerMonth,
    ],
    buyLink: 'mailto:sales@waltzing.at',
  },
  {
    title: messages.business,
    monthlyPrice: (
      <span>
        79<b>*</b>
      </span>
    ),
    monthlyPayment: messages.monthlyPayment,
    limitMessage: messages.limitMessageBusiness,
    featureList: [
      messages.featureUnlimitedApiKeys,
      messages.featureProductVersionLifeTime,
      messages.featureMultipleProductsPerLicense,
      messages.featureEMailNotification,
      messages.featureValidityAutoRenew,
    ],
    notesList: [messages.featureRequestPerMonthNote],
    featureHeaderText: messages.featureHeaderTextBusiness,
    buyLink: 'mailto:sales@waltzing.at',
  },
  {
    title: messages.onPremise,
    monthlyPrice: 79,
    monthlyPayment: messages.monthlyPayment,
    limitMessage: messages.limitMessageOnPremise,
    featureList: [
      messages.featureDockerized,
      messages.featureLicenseManagingInHouse,
    ],
    featureHeaderText: messages.featureHeaderTextOnPremise,
    buyLink: 'mailto:sales@waltzing.at',
  },
];

class Time extends React.Component {
  render() {
    return (
      <Layout>
        <ProductPage
          headerImg={'/product/Waltzing-License-Mockup_low-quality.jpg'}
          logoImg={'/product/license.svg'}
          productName="Waltzing License"
          productDescription={<FormattedMessage {...messages.description} />}
          pricing={pricing}
        />
      </Layout>
    );
  }
}

export default Time;



// WEBPACK FOOTER //
// ./src/routes/license/index.js